type DashboardHeaderProps = {
  connectedAccountName: string
}

export const DashboardHeader = ({ connectedAccountName }: DashboardHeaderProps) => {
  return (
    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
      <div>
        <h1 className="text-3xl font-bold tracking-tight text-gray-900 dark:text-white">
          {connectedAccountName} Dashboard
        </h1>
        <p className="mt-1 text-gray-600 dark:text-gray-300">Charter burndown and expense management overview</p>
      </div>
    </div>
  )
}

export default DashboardHeader
